import { createFileRoute } from '@tanstack/react-router';
import { ApiKeysSettingsPage } from '../../components/settings/api-keys-settings.js';

export const Route = createFileRoute('/settings/api-keys')({
  component: ApiKeysSettingsPage,
});
